import type {
    Contact,
    ContactId,
    JsonApiLink,
    TaskId,
    TeamId,
    UnixTimestamp,
    UrlString,
    UserId,
} from '../types';
import type {TasksState} from './tasks-reducer';

export const REDUCER_KEY = 'tasks';
export type ReducerKey = 'tasks';

export type TasksModuleState = Partial<Record<ReducerKey, TasksState>>;

export type TaskRecurringPeriod = '7' | '30' | '90';

export type TaskCreatorEntity = {
    id: string;
    name: string;
    type: 'activities';
};

export type Task = {
    id: TaskId;
    type: 'tasks';
    title: string;
    href: UrlString;
    description: string | null | undefined;
    recurringPeriod: TaskRecurringPeriod | null | undefined;
    dueTime: UnixTimestamp;
    createdTime: UnixTimestamp;
    deletedTime: UnixTimestamp | null | undefined;
    completedTime: UnixTimestamp | null | undefined;
    isCompleted: boolean;
    isOverdue: boolean;
    isRecurring: boolean;
    isAiGenerated: boolean;
    creatorEntity: TaskCreatorEntity | null | undefined;
    htmlUrl: UrlString;
    links: {
        creator: UserId;
        completer: UserId | null | undefined;
        assignee: UserId | TeamId;
        relatedEntity: ContactId;
    };
};

export type TasksApiResponse = {
    meta: {
        count?: number;
        total?: number;
    };
    links:
        | {
              [key: string]: JsonApiLink;
          }
        | [];
    tasks: Task[];
    relatedEntities?: Contact[];
    users?: any[];
};
